// @flow

import React, { Component } from 'react';

// redux
import { connect } from 'react-redux';
import { fetchResourceInclParams } from '../../actions/resources';
import { fetchSingleSharedResource } from '../../actions/shared';

// models
import type { ResourceType } from '../../types/resource';

// shared components
import RecordDetails from '../shared/RecordDetails';

type Props = {
  match: {
    params: {
      id: number
    }
  },
  location: {},
  token: string,
  accessToken: string,
  resource: ResourceType,
  fetchCompleteResource: (id: number, params: string) => void,
  fetchSharedResource: (token: string, id: number) => void
};

const mapStateToProps = (appState) => ({
  resource: appState.resource,
  sharedResource: appState.sharedResource
});

const mapDispatchToProps = (dispatch) => ({
  fetchCompleteResource: ((id, params) => dispatch(fetchResourceInclParams(id, params))),
  fetchSharedResource: ((token, id) => dispatch(fetchSingleSharedResource(token, id)))
});

class Record extends Component {
  componentWillMount() {
    const { match } = this.props;
    const token = match && match.params && match.params.token;
    const id = parseInt(match && match.params && match.params.id, 10);
    if (token) this.props.fetchSharedResource(token, id);
    else this.props.fetchCompleteResource(id, 'related,files');
  }

  props: Props

  render() {
    const { match } = this.props;
    const token = match && match.params && match.params.token;
    return (
      <RecordDetails
        fileviewerReg={!token}
        location={this.props.location}
        token={token}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Record);



// WEBPACK FOOTER //
// ./src/components/pages/record.js